import { attr } from '@ember-data/model';
import Mixin from '@ember/object/mixin';

// eslint-disable-next-line ember/no-new-mixins
export default Mixin.create({
  cursorId: attr(),
});
